import React, { useEffect } from "react";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import DateRangeIcon from "@material-ui/icons/DateRange";
import moment from "jalali-moment";
import { baseUrl } from "@jumbo/constants/baseUrl";
import HubbleRequests from "services/hubble";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    maxWidth: "300px",
  },
  formTitleContainer: {
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "17px",
    color: theme.palette.primary.main,
  },
  Title: {
    padding: "0.8rem",
    backgroundColor: theme.palette.grey[200],
    fontWeight: "bold",
  },
  userInput: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
  },
}));

const HubbleRefereeDetailsContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { hubbleSingleReferee } = useSelector(({ hubble }) => hubble);
  const { id } = useParams();

  useEffect(() => {
    dispatch(HubbleRequests.getHubbleRefereeById(id));
  }, [id, dispatch]);

  const getLevel = (level) => {
    let lev = "انتخابی";
    if (level === "level1") {
      lev = "انتخابی";
    } else if (level === "level2") {
      lev = "مقدماتی";
    } else if (level === "level3") {
      lev = "نیمه نهایی";
    } else if (level === "level4") {
      lev = "نهایی";
    }
    return lev;
  };

  return (
    <GridContainer>
      <Grid item md={8} xs={12}>
        <Paper>
          <Box className={classes.formTitleContainer}>
            {hubbleSingleReferee?.hubbleForm?.major}
          </Box>
          <Box className={classes.Title}>نام ارسال کننده</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.participent?.fullName}
          </Box>
          <Box className={classes.Title}>کد ملی ارسال کننده</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.participent?.nationalCode}
          </Box>
          <Box className={classes.Title}>کد پرسنلی ارسال کننده</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.participent?.personnelCode}
          </Box>
          <Box className={classes.Title}>توضیحات</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.description}
          </Box>
          <Box className={classes.Title}>آدرس</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.address}
          </Box>
          <Box className={classes.Title}>شهر</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.city}
          </Box>
          <Box className={classes.Title}>استان</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.state || "تعیین نشده"}
          </Box>
          <Box className={classes.Title}>محل کار صاحب کد پرسنلی</Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.workplace ||
              "تعیین نشده"}
          </Box>
          <Box className={classes.Title}> شغل </Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.ownerJob ||
              "تعیین نشده"}
          </Box>
          <Box className={classes.Title}> جنسیت </Box>
          <Box className={classes.userInput}>
            {hubbleSingleReferee?.hubbleForm?.personal?.gender === "male"
              ? "مرد"
              : "زن"}
          </Box>
          <Box className={classes.Title}>مرحله</Box>
          <Box className={classes.userInput}>
            {getLevel(hubbleSingleReferee?.hubbleForm?.level)}
          </Box>
          {hubbleSingleReferee?.hubbleForm?.groupMode && (
            <>
              <Box className={classes.Title}>نام گروه</Box>
              <Box className={classes.userInput}>
                {hubbleSingleReferee?.hubbleForm?.groupName}
              </Box>

              <Box className={classes.Title}>اعضای گروه</Box>
              <Box className={classes.userInput}>
                {hubbleSingleReferee?.hubbleForm?.groupUsers.map(
                  (item, index) => {
                    return (
                      <Box key={index}>
                        {item.fullName + " - " + item.nationalCode}
                      </Box>
                    );
                  }
                )}
              </Box>
            </>
          )}
          <Box className={classes.Title}>فایل </Box>
          <Box className={classes.userInput}>
            <a
              href={`${baseUrl}file/get/${hubbleSingleReferee?.hubbleForm?.file}`}
              target="_blank"
            >{`${baseUrl}file/get/${hubbleSingleReferee?.hubbleForm?.file}`}</a>
          </Box>
        </Paper>
      </Grid>
      <Grid item md={4} xs={12}>
        <Paper elevation={3}>
          <Box className={classes.formTitleContainer}>جزئیات </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <VpnKeyIcon style={{ marginLeft: "5px" }} />
              شناسه :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?._id}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <DateRangeIcon style={{ marginLeft: "5px" }} />
              تاریخ ارسال :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee
              ? moment(hubbleSingleReferee.createdAt)
                  .locale("fa")
                  .format("HH:mm:ss  YYYY/MM/DD ")
              : null}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <DateRangeIcon style={{ marginLeft: "5px" }} />
              تاریخ به‌روز‌رسانی :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee
              ? moment(hubbleSingleReferee.updatedAt)
                  .locale("fa")
                  .format("HH:mm:ss  YYYY/MM/DD ")
              : null}
          </Box>
        </Paper>

        <Paper elevation={3} style={{ marginTop: "20px" }}>
          <Box className={classes.formTitleContainer}>داور </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              نام و نام خانوادگی :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.referee.fullName}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              کد ملی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.referee.nationalCode}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              کد پرسنلی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.referee.personnelCode}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              شماره تلفن
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.referee.phone}
          </Box>
        </Paper>

        <Paper elevation={3} style={{ marginTop: "20px" }}>
          <Box className={classes.formTitleContainer}>داوری </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              راه یافته به مرحله بعدی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.allowedToProceedToNextLevel ? "بله" : "خیر"}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              نظر داور
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.comment}
          </Box>
        </Paper>

        <Paper elevation={3} style={{ marginTop: "20px" }}>
          <Box className={classes.formTitleContainer}>امتیازات </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              جذابیت و برانگیزانندگی (اثر ارسالی برای بقیه چقدر می تواند جذاب
              باشد؟)
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreAttractiveness}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              بداعت و خلاقیت (اثر ارسال شده چقدر خلاقانه و جدید است؟)
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreCreativity}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              پیام‌مندی و درونمایه‌ی اثر(اثر ارسال شده حامل چه پیامی می باشد؟)
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreMessage}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              اصالت و هویت کار اثر ارسال شده چقدر اصیل و با هویت است؟)
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreOriginality}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              تیمی بودن (ناظر به مجریان) داستان‌مندی/ تعاملی بودن (با
              تماشاچیان)/ و..
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreOther}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              کیفیت و قدرت اجرا (شرکت کننده ایده خود را چقدر باکیفیت، قدرتمند و
              مسلط اجرا نموده است؟)
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreQualityOfPerformance}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              مچموع امتیاز
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleSingleReferee?.scoreTotal}
          </Box>
        </Paper>
      </Grid>
    </GridContainer>
  );
};

export default HubbleRefereeDetailsContainer;
